import TrustStrip from "@/components/layout/TrustStrip";
import { HeroSection } from "@/components/home/HeroSection";
import { MissionSection } from "@/components/home/MissionSection";
import { FeaturedProductSection } from "@/components/home/FeaturedProductSection";
import { SolarHotWaterSection } from "@/components/home/SolarHotWaterSection";
import { DualAudienceSection } from "@/components/home/DualAudienceSection";
import { WhyWorkWithUsSection } from "@/components/home/WhyWorkWithUsSection";
import { LeadingTheWaySection } from "@/components/home/LeadingTheWaySection";
import { WhyStartWithHotWaterSection } from "@/components/home/WhyStartWithHotWaterSection";
import { WhatWeReplaceSection } from "@/components/home/WhatWeReplaceSection";
import { StagedVisionTimelineSection } from "@/components/home/StagedVisionTimelineSection";
import { CalculatorPreviewSection } from "@/components/home/CalculatorPreviewSection";
import { LeadCaptureSection } from "@/components/home/LeadCaptureSection";

export default function Home() {
  return (
    <>
      <HeroSection />
      <TrustStrip />
      <MissionSection />
      <FeaturedProductSection />
      <SolarHotWaterSection />
      <DualAudienceSection />
      <WhyWorkWithUsSection />
      <LeadingTheWaySection />
      <WhyStartWithHotWaterSection />
      <WhatWeReplaceSection />
      <StagedVisionTimelineSection />
      <CalculatorPreviewSection />
      <LeadCaptureSection />
    </>
  );
}
